import { MultiselectionProps, Option } from '../type'
import MultiselectionOption from './MultiselectionOption'

const MultiSelection = ({
  options,
  onChange,
  tabIndex,
  direction,
  heightClass,
  optionLabelsPosition,
  checkedOption: checkedOptions,
  disabled = false,
  nonFocusable = false,
  ...props
}: MultiselectionProps) => {
  const isBeforePositioned =
    optionLabelsPosition === 'top' || optionLabelsPosition === 'left'

  const isOptionChecked = ({ uuid }: Option) => !!checkedOptions[uuid]

  const shouldShowOption = (index: number, beforePositioned: boolean) => {
    if (optionLabelsPosition !== 'alternating') {
      return true
    }

    const isEven = !(index % 2)

    return isEven ? !beforePositioned : beforePositioned
  }

  return (
    <>
      {options?.map((option, index) => (
        <MultiselectionOption
          key={option.uuid}
          option={option}
          index={index}
          onChange={onChange}
          tabIndex={tabIndex}
          direction={direction}
          heightClass={heightClass}
          optionLabelsPosition={optionLabelsPosition}
          checkedOption={checkedOptions}
          disabled={disabled}
          nonFocusable={nonFocusable}
          isBeforePositioned={isBeforePositioned}
          shouldShowOption={shouldShowOption}
          isOptionChecked={isOptionChecked}
          {...props}
        />
      ))}
    </>
  )
}

export default MultiSelection
